// src/components/strumenti/ConsumoEnergia.js — W442. Consumo e costo dell'energia di un apparecchio
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, euro, fmt } from "./UiStrumento";
import { consumoEnergia } from "../../utils/calcoliStrumenti";

export default function ConsumoEnergia() {
  const { v, set, n, azzera } = useCampi({ w:"", ore:"", giorni:"", prezzo:"" });
  const r = consumoEnergia(n("w"), n("ore"), n("giorni"), n("prezzo"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Potenza assorbita (W)" valore={v.w} onChange={set("w")} placeholder="Es. 2000"/>
        <Campo etichetta="Ore di funzionamento al giorno" valore={v.ore} onChange={set("ore")} placeholder="Es. 8"/>
        <Campo etichetta="Giorni" valore={v.giorni} onChange={set("giorni")} placeholder="Es. 22"/>
        <Campo etichetta="Prezzo energia (€/kWh, facoltativo)" valore={v.prezzo} onChange={set("prezzo")} placeholder="Es. 0,25"/>
      </Griglia>
      <Risultato settore="elettrico" titolo="Energia consumata" valore={fmt(r?.kwh, 2)} unita="kWh"
        righe={r ? [["Al giorno", fmt(r.kwhGiorno, 3) + " kWh"], r.costo !== null && ["Costo", euro(r.costo)]] : []}/>
      <Formula>kWh = W ÷ 1000 × ore al giorno × giorni; costo = kWh × €/kWh. Usa la potenza realmente assorbita (non quella di targa massima) e il prezzo totale in bolletta per kWh.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
